import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import {
  SSJBeaconButton,
  SSJBeaconInputField,
  SSJBeaconRadioGroup,
  SSJBeaconRadioButton,
  SSJBeaconErrorMessageSummary,
} from '../../../Shared/Beacon/Registry';

import { incrementStep } from '../../../../redux/modules/transferFunding/stepActions';
import './RolloverType.scss';
import { RolloverConstants } from '../../RolloverConstants';
import Dollar from '../../../../assets/images/Dollar.svg';
import { putFundingTrackingData } from '../../../../redux/modules/fundingTrackingData/fundingTrackingData.module';
import rightArrow from '../../../../assets/images/beacon-chevron-right.svg';
import { beaconPattern } from '../../../../utils/fundingMethod/fundingMethodUtils';
import { dispatchPageLoad } from '../../../../redux/utils/analytics-helper';

const RolloverType = () => {
  useEffect(() => {
    dispatchPageLoad('Choose Type');
  }, []);
  const dispatch = useDispatch();
  const fundingTrackingDataPayload = useSelector(
    (state) => state?.fundingTrackingData?.payload
  );
  const [errors, setErrors] = useState([]);
  const [errorCounter, setErrorCounter] = useState(0);
  const rolloverTypeRef = useRef(
    fundingTrackingDataPayload?.onboardingDataStore?.onboardingDatastoreRollover
      ?.onboardingRolloverType || ''
  );
  const rolloverAmountRef = useRef(
    fundingTrackingDataPayload?.onboardingDataStore?.onboardingDatastoreRollover
      ?.rolloverAmount || ''
  );

  useEffect(() => {
    if (errorCounter > 0) {
      if (
        rolloverTypeRef.current.value !== 'DIRECT' &&
        rolloverTypeRef.current.value !== 'INDIRECT'
      ) {
        const fundingTypeElement = document.querySelector('#RolloverType');
        if (fundingTypeElement) {
          fundingTypeElement?.evaluateValidations();
        }
      }
      if (
        !rolloverAmountRef.current.value ||
        rolloverAmountRef.current.value < 1000
      ) {
        const amtElement = document.querySelector('#amountInput');
        if (amtElement) {
          amtElement?.evaluateValidations();
        }
      }
    }
  }, [errorCounter]);

  /* eslint-disable */
  useEffect(() => {
    if (!rolloverTypeRef?.current?.value) {
      rolloverTypeRef.current.value =
        fundingTrackingDataPayload?.onboardingDataStore
          ?.onboardingDatastoreRollover?.onboardingRolloverType || '';

      rolloverAmountRef.current.value =
        fundingTrackingDataPayload?.onboardingDataStore
          ?.onboardingDatastoreRollover?.rolloverAmount || '';
    }
    //fixed flickering as rolloverTypeRef value is setting up UNKNOWN
    if (rolloverTypeRef?.current.value !== 'UNKNOWN') {
      setErrors([]);
    }
  }, [rolloverTypeRef?.current.value, rolloverTypeRef?.current.value]);

  function submitRolloverContentType() {
    let formIsValid = true;
    //reseting error list
    setErrors([]);
    if (
      rolloverTypeRef.current.value !== 'DIRECT' &&
      rolloverTypeRef.current.value !== 'INDIRECT'
    ) {
      setErrors((prevState) => [
        ...prevState,
        { message: 'Please Select Rollover Type' },
      ]);
      setErrorCounter((prevState) => prevState + 1);
      formIsValid = false;
    }
    if (rolloverAmountRef.current.value < 1000) {
      setErrors((prevState) => [
        ...prevState,
        { message: 'Please enter amount of $1000 or above' },
      ]);
      setErrorCounter((prevState) => prevState + 1);
      formIsValid = false;
    }
    //
    if (formIsValid && fundingTrackingDataPayload?.onboardingDataStore) {
      const value = Number(rolloverAmountRef.current.value);
      //
      fundingTrackingDataPayload.onboardingDataStore.onboardingDatastoreRollover = {
        ...fundingTrackingDataPayload.onboardingDataStore
          .onboardingDatastoreRollover,
        onboardingRolloverType: rolloverTypeRef.current.value,
        rolloverAmount: value,
      };
      dispatch(putFundingTrackingData(fundingTrackingDataPayload));
      window.scrollTo(0, 0);
      // initilizing funding data
      dispatch(incrementStep());
    }
  }

  const RolloverForm = () => {
    return (
      <div className="rollover-type-container">
        <div className="form">
          <SSJBeaconRadioGroup
            id="RolloverType"
            className="rollover-type"
            name="RolloverType"
            label={RolloverConstants?.rolloverTypePage?.formHeading}
            hint={RolloverConstants?.rolloverTypePage?.formDescription}
            required="true"
            errors-map='{"required": "Select Rollover Type"}'
            ref={rolloverTypeRef}
          >
            <SSJBeaconRadioButton
              label={RolloverConstants?.rolloverTypePage?.directRolloverLabel}
              id="RolloverTypeDirect"
              value="DIRECT"
              checked={rolloverTypeRef.current.value === 'DIRECT'}
            />
            <SSJBeaconRadioButton
              label={RolloverConstants?.rolloverTypePage?.indirectRolloverLabel}
              id="RolloverTypeIndirect"
              value="INDIRECT"
              checked={rolloverTypeRef.current.value === 'INDIRECT'}
            />
          </SSJBeaconRadioGroup>

          <div className="group">
            <label className="beacon-label" htmlFor="amount-balance">
              {RolloverConstants?.rolloverTypePage?.amountHeading}
            </label>
            <div className="beacon-label_hint">
              {RolloverConstants?.rolloverTypePage?.amountDescription}
            </div>
            <SSJBeaconInputField
              id="amountInput"
              name="amountInput"
              ref={rolloverAmountRef}
              icon-url={Dollar}
              icon-position="left"
              label=" "
              className="beacon-input"
              type="number"
              maxlength="15"
              min={1000}
              format-type="regexp"
              format={beaconPattern.amountWithTwoDecimals}
              required="true"
              value={rolloverAmountRef.current.value}
              errors-map='{"min":"Please enter amount of $1000 or above","noMatchPattern":"Please enter amount of $1000 or above"}'
            />
          </div>

          <SSJBeaconButton
            id="detials-submit-btn"
            className="submit-btn rollover-type-page-continue-btn"
            label="Continue"
            scale="jumbo"
            onClick={submitRolloverContentType}
          >
            <img
              slot="icon"
              icon-align="right"
              alt="Continue Button"
              className="rollover-continue-arrow-icon"
              fill="none"
              height="16"
              width="16"
              src={rightArrow}
            />
          </SSJBeaconButton>
        </div>
      </div>
    );
  };

  return (
    <div className="rollover-type-page">
      <div className="page-header">
        <div className="title">
          {RolloverConstants?.rolloverTypePage?.heading}
        </div>
        <div className="description">
          {RolloverConstants?.rolloverTypePage?.description}
        </div>
      </div>
      {errors.length > 0 && (
        <div className="error-summary">
          <SSJBeaconErrorMessageSummary
            id="error-message-summary"
            errors={errors}
          />
        </div>
      )}
      <RolloverForm />
    </div>
  );
};

export default RolloverType;
